import {merge} from './utils.js'
import store from './store.js'

const limit = 10

export var list = {
  data() {
    return {
      tableStorage: [],
      checkedItem:[],
      total: 0,
      opts: {},
      args:{},
      page: {
        limit:this.limit || limit,
        count:0,
        current:1,
        total: 1,
        sel:this.limit || limit,
      },
      callback: function(res) {}
    }
  },
  watch: {
    'page.current': function (val) {
      this.$router.replace({path:this.$route.path,query:{page:this.page.current}});
      this.getList(false)
    },
    'page.sel':function (val){
       this.limit = val
       this.getList()
    }
  },
  computed: {

  },
  methods: {
    getTotal() {
      return this.total;
    },
    getArgs() {
      var obj = {}
      if (this.search && this.search.input) {
        this.search.input.forEach((val, i) => {
          if (Array.isArray(val.key)) {
            val.key.forEach((v,i) => obj[v] = Array.isArray(val.value) ? val.value[i] : '')
          } else if (val.key) {
            obj[val.key] = val.value
          } else if (val.keys) {
            !obj[val.keys] && (obj[val.keys] = [])
            val.value && obj[val.keys].push(val.value)
          } else if(val.values) {
            obj = merge(obj,val.values);
          }
        })
      }
      if(obj.level != 0 && (obj.level==-1 || !obj.level)) {
        obj.enable_level=false
      } else {
        obj.enable_level = true
      }
      this.args =  obj;
    },
    sort(data) {
      this.opts.order = data.attr||data.space;
      this.opts.sort = data.up ? 'desc':'asc';
      this.refresh();
    },
    getQueryParams(obj) {
      var paramStr="";
      if(obj instanceof String||obj instanceof Number||obj instanceof Boolean){
        paramStr += "&"+key+"="+encodeURIComponent(obj);
      }else {
        for(var p in obj) {
          if(obj[p] instanceof Array) {
            for(var item in obj[p]) {
              if(item!==undefined) {
                paramStr += "&" + p + "=" + encodeURIComponent(obj[p][item]);
              }
            }
          } else {
            if(obj[p]!==undefined) {
              paramStr += "&" + p + "=" + encodeURIComponent(obj[p]);
            }
          }
        }
      }
      return paramStr.substr(1);
    },
    getList(clearStorage = true, callback) {
      //this.table.tbody = [];
      var index = this.page.current - 1
      var pageLimit = this.limit || limit
      if (clearStorage === true) {
        this.tableStorage = []
      }else if (this.tableStorage[index]) {
        this.table.tbody = this.tableStorage[index]
        return
      }

      if (this.table.tfoot !== false) {
        merge(this.opts, {
            offset: index * pageLimit,
            limit: pageLimit
        })
      }
      this.getArgs();
      merge(this.opts, this.args)
      if (this.$route.params.app_id) {
        merge(this.opts, {
          app_id: this.$route.params.app_id,
        })
      }
      // 值为空就不发送
      Object.keys(this.opts).forEach(val => {
        if (this.opts[val] === '' || this.opts[val] === null) {
          this.opts[val] = undefined
        }
      })
      var url = this.getListUrl.indexOf('?') > 0 ? this.getListUrl + "&" + this.getQueryParams(this.opts) : this.getListUrl + "?" + this.getQueryParams(this.opts);
      this.$http.get(url).then((res) => {
        var data = res.data.data || []
        if (this.handleTbody) {
          var newData = this.handleTbody(data,res.data)
          if(newData) {
            data = newData;
          }
        }
        this.tableStorage[index] = res.data.data;
        this.table.tbody = this.tableStorage[index]
        if (typeof(res.data.total) === 'number') {
          this.total = res.data.total
          this.page.count = res.data.total
          this.page.total = Math.ceil(res.data.total / pageLimit) || 1
        }
        if (callback && typeof(callback) === 'function') {
          this.callback = callback
        }
        this.callback(res.data)
      })
    },
    del(data) {
      if (window.confirm('确认删除吗')) {
        var key = 'id';
        var valueKey = this.delKey || 'id'
        return this.$http.post(this.delUrl, {
          [valueKey]: [data[valueKey]]
        }).then((res) => {
          this.getList()
        }).catch(() => {
          this.getList()
        })
      }
    },
    resetPage() {
      this.page.count = 0
      this.page.current = 1
      this.page.total = 1
    },
    refresh() {
      this.tableStorage = []
      this.getList();
      //this.page.current == 1 ? this.getList() : this.resetPage()
    },
    clear() {
      if(this.$refs.table) {
        this.$refs.table.checkedItem = [];
      }
    },
    handle() {
      this.getArgs();
      merge(this.opts, this.args)
      this.page.current = 1
      this.$router.replace({path:this.$route.path,query:{args:true}});
      store.save('args',this.args)
      this.refresh()
    },
  },
  mounted() {
    this.page.limit = this.limit || limit
    if(this.$route.query.args=='true') {
      var opts = store.fetch('args')
      for (var x in opts) {
        if (opts[x] && this.search && this.search.input) {
          var item = this.search.input.filter(v=>v.key == x);
          if (item.length > 0) {
            item[0].value = opts[x]
          } else {
            var item = this.search.input.filter(v=>v.values && v.values.hasOwnProperty(x));
            if (item.length > 0) {
              item[0].values[x] = opts[x];
            }
          }
        }
      }
    }
    if (!this.delayGet) {
      this.getList()
    }
  }
}


/*排序*/
export var order = {
  watch: {
    'search.order.value': function(val) {
      merge(this.opts, {order: val})
      this.refresh()
    }
  }
}
